<template>
  <div>
    <v-row justify="center">
      <v-col
        cols="12"
        :md="!view?12:8"
      >
        <base-material-card icon="mdi-cash-register">
          <template v-slot:after-heading>
            <div class="title font-weight-light">
              <span class="body-1">Создание фискальной операции</span>
            </div>
          </template>
          <base-material-tabs color="warning">
            <v-tab>
              Оборудование
            </v-tab>
            <v-tab>
              Параметры запроса
            </v-tab>
            <v-tab-item>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="form.request.client"
                    clearable
                    v-if="$store.state.access[15][5]"
                    :filter="client_filter"
                    :items="select.clients"
                    item-value="id"
                    label="Наименование клиента"
                    :disabled="view"
                    :loading="search.client.loading"
                    :search-input.sync="search.client.text"
                    hide-no-data
                    hint="Введите минимум три символа для поиска"
                    @change="client_selected"
                  >
                    <template v-slot:selection="{item}">
                      <v-list>
                        <v-list-item-content>
                          <v-list-item-title> {{ item.legal.name.short }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list>
                    </template>
                    <template v-slot:item="{item}">
                      <v-list two-line>
                        <v-list-item-content>
                          <v-list-item-title>  {{ item.legal.name.short }}</v-list-item-title>
                          <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="form.request.type"
                    :items="select.type"
                    label="Тип устройства"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-autocomplete
                    v-model="form.request.equipment"
                    :filter="equipment_filter"
                    return-object
                    :items="select.equipment.filter(a=>!form.request.type || a.type == form.request.type)"
                    label="Поиск оборудования"
                    :disabled="view || !form.request.client"
                    hide-no-data
                    hint="Введите минимум три символа для поиска"
                    @change="equipment_selected"
                  >
                    <template v-slot:selection="{item}">
                      <v-list>
                        <v-list-item-content>
                          <span v-if="item && item.device">
                            <font color="#315bbf">{{ dict.type[item.type] }} {{ dict.device[item.device] }}</font>
                          </span>
                          <br>
                          <span v-if="item">
                            {{ item.serial }}
                          </span>
                        </v-list-item-content>
                      </v-list>
                    </template>
                    <template v-slot:item="{item}">
                      <v-list two-line>
                        <v-list-item-content>
                          <span v-if="item && item.device">
                            <font color="#315bbf">{{ dict.type[item.type] }} {{ dict.device[item.device] }}</font>
                          </span>
                          <br>
                          <span v-if="item">
                            {{ item.serial }}
                          </span>
                        </v-list-item-content>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    v-if="form.request.equipment.id"
                    :items="select.device.filter(a=>a.id == form.request.equipment.device)[0].settings"
                    :headers="[
                      {value: 'description', text: 'Описание', width: 300},
                      {value: 'value', text: 'Значение', width: 150},
                    ]"
                    no-data-text="Нет данных для отображения"
                  >
                    <template v-slot:item.description="{item}">
                      <v-text-field
                        v-model="item.description"
                        readonly
                      />
                    </template>

                    <template v-slot:item.value="{item}">
                      <v-text-field
                        v-if="item.type == 0"
                        v-model="form.request.equipment.settings[item.key]"
                      />
                      <v-checkbox
                        v-if="item.type == 1"
                        v-model="form.request.equipment.settings[item.key]"
                      />
                      <v-select
                        v-if="item.type == 2"
                        v-model="form.request.equipment.settings[item.key]"
                        :items="item.values"
                      />
                      <v-textarea
                        v-if="item.type == 3"
                        v-model="form.request.equipment.settings[item.key]"
                      />
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="form.request.action"
                    :items="select.action"
                    label="Тип запроса"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  Данные о кассире
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.request.cashier.name"
                    label="Имя кассира"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.request.cashier.inn"
                    label="ИНН кассира"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action === 0 || form.request.action === 5">
                <v-col cols="12">
                  Данные о владельце
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.owner.name"
                    label="Имя"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.owner.inn"
                    label="ИНН"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.owner.place"
                    label="Место установки"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.owner.address"
                    label="Адрес"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action === 0">
                <v-col cols="12">
                  Данные ОФД
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.ofd.name"
                    label="Имя"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.ofd.inn"
                    label="ИНН"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.settings.owner.email"
                    label="E-mail"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.ofd.server"
                    label="URL"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.ofd.port"
                    label="Порт"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action === 0">
                <v-col cols="12">
                  Налоговый режим
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.tax.system"
                    label="Налоговый режим"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.settings.tax.url"
                    label="Сайт налоговой"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action === 0">
                <v-col cols="12">
                  РН
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.settings.rn"
                    label="РН ККТ"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action == 5">
                <v-col cols="12">
                  Налоговый режим
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.request.payment.tax.system"
                    label="Налоговый режим"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action == 4">
                <v-col cols="12">
                  Тип отчета
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.request.report"
                    label="Вид отчета"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action == 6">
                <v-col cols="12">
                  HTML
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.request.html"
                    label="Вид отчета"
                  />
                </v-col>
              </v-row>
              <v-row v-if="form.request.action == 5">
                <v-col cols="12">
                  <v-data-table
                    :items="form.request.payment.items"
                    :headers="[
                      {value: 'name', text: 'Наименование'},
                      {value: 'price', text: 'Цена'},
                      {value: 'amount', text: 'Количество'},
                      {value: 'tax_type', text: 'Тип ставки НДС'},
                    ]"
                    no-data-text="Нет данных для отображения"
                  >
                    <template v-slot:item.name="{item}">
                      <v-text-field
                        v-model="item.name"
                        @input="item_change"
                      />
                    </template>
                    <template v-slot:item.price="{item}">
                      <v-text-field
                        v-model="item.price"
                        type="number"
                        @input="item_change"
                      />
                    </template>
                    <template v-slot:item.amount="{item}">
                      <v-text-field
                        v-model="item.amount"
                        type="number"
                        @input="item_change"
                      />
                    </template>
                    <template v-slot:item.tax_type="{item}">
                      <v-text-field
                        v-model="item.tax_type"
                        type="number"
                        @input="item_change"
                      />
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    color="error"
                    @click="send_request"
                  >
                    <span class="mx-10">Отправить запрос</span>
                  </v-btn>
                </v-col>
                <v-col v-if="view" cols="12">
                  <div>
                    <pre class="ma-5"><code class="json">{{ answer }}</code></pre>
                  </div>
                </v-col>
              </v-row>
            </v-tab-item>
          </base-material-tabs>
        </base-material-card>
      </v-col>
    </v-row>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </div>
</template>

<script>
  export default {
    props: ['create', 'change', 'view'],
    data: () => ({
        loading: false,
        answer: null,
        form: {
            settings: {
                    owner: {
                        name: 'Кртей',
                        inn: '',
                        email: '',
                        address: '',
                        place: ''
                    },
                    ofd: {
                        name: '',
                        inn: '',
                        server: '',
                        port: ''
                    },
                    tax: {
                        system: '',
                        url: ''
                    },
                    rn: '',
                    timeout: 30
                },
            request: {
                client: '',
                equipment: {},
                action: '',
                cashier: {
                    name: '',
                    inn: ''
                },

                html: '',
                report: 'X',
                payment: {
                    sum: 100,
                    items: [
                        {
                            new: true
                        }
                    ],
                    tax: {
                        system: ''
                    },
                    type: 'INCOME'
                }
            }
        },
        select: {
            clients: [],
            equipment: [],
            type: [],
            device: [],
            action: [
                { value: 0, text: 'Регистрация фискального режима' },
                { value: 1, text: 'Закрытие фискального режима' },
                { value: 2, text: 'Открытие смены' },
                { value: 3, text: 'Закрытие смены' },
                { value: 4, text: 'Печать отчета' },
                { value: 5, text: 'Создание заказа' },
                { value: 6, text: 'Печать HTML' },
                { value: 7, text: 'Доп.информация' },
                { value: 8, text: 'Статус операции' },
                { value: 9, text: 'Отмена документа' }
            ]
        },
        dict: {
            type: {},
            device: {}
        },
        search: {
            client: {
                loading: false,
                text: ''
            }
        }
    }),
    computed: {

    },
    watch: {
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      }
    },
    mounted: function () {
        for (const x in this.$store.state.dict.device_type) {
            this.dict.type[Number(x)] = this.$store.state.dict.device_type[x].name
            this.select.type.push({
                value: Number(x),
                text: this.$store.state.dict.device_type[x].name
            })
        }
        this.axios.post('/api/device/list', {})
        .then(result => {
            if (!result.data.error) {
              this.select.device = result.data.data
              for (const x in result.data.data) {
                this.dict.device[result.data.data[x].id] = result.data.data[x].model
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
    },
    methods: {
        equipment_selected: function () {
            const equipment = this.form.request.equipment
            this.form.point = this.form.request.equipment.point
            this.form.equipment = this.form.request.equipment.id
            this.form.settings.rn = equipment.settings.rn
            this.form.settings.ofd.name = equipment.settings.ofd_name
            this.form.settings.ofd.inn = equipment.settings.ofd_inn
            this.form.settings.ofd.server = equipment.settings.ofd_server
            this.form.settings.ofd.port = equipment.settings.ofd_port
            this.form.settings.tax.system = equipment.settings.tax_system
            this.form.settings.tax.url = equipment.settings.tax_url
            this.form.settings.timeout = equipment.settings.ofd_timeout
            this.form.settings.owner.email = equipment.settings.ofd_email
        },
        send_request: function () {
            this.answer = null
            this.loading = true
            this.form.request.payment.items = this.form.request.payment.items.filter(a => !a.new || a.new == false)
            this.axios.post('/api/fiscal/create', this.form)
            .then(result => {
                this.loading = false
                this.answer = result.data
                this.$router.push('/admin/fiscal/list')
            })
            .catch(e => {
                this.loading = false
                console.log(e)
                this.answer = e
            })
        },
        item_change: function (item) {
            console.log(item)
            if (item.new) {
            item.new = false
            this.form.request.payment.items.push({
                new: true,
            })
            }
        },
        equipment_filter: function (item, query, text) {
            if (item.number.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.serial.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.device && this.dict.device[item.device].toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.type && this.dict.type[item.type].toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            return false
        },
        load_clients: function (text) {
            this.search.client.loading = true
            this.axios.post('/api/client/list', {
            search: text,
          limit: 10
            })
            .then(result => {
            this.search.client.loading = false
            if (!result.data.error) {
                this.select.clients = result.data.data
            }
            })
            .catch(e => {
            console.log(e)
            this.search.client.loading = false
            })
        },
        client_selected: function () {
            const client = this.select.clients.filter(a => a.id == this.form.request.client)[0]
            this.form.client = client.id
            this.form.settings.owner.name = client.legal.name.short
            this.form.settings.owner.inn = client.legal.inn
            if (client.legal.addresses && client.legal.addresses.filter(a => a.type == 1)[0]) {
                this.form.settings.owner.address = client.legal.addresses.filter(a => a.type == 1)[0].value
            }
            this.axios.post('/api/equipment/list', {
                client: this.form.request.client,
            })
            .then(result => {
                if (!result.data.error) {
                    this.select.equipment = result.data.data
                }
            })
            .catch(e => {
                console.log(e)
            })
        },
        client_filter: function (item, query, text) {
            if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
            return false
        },
    },
  }
</script>
